module.exports = __webpack_public_path__ + "img/pliers.be5030ca.webp";